export function useSlideTitle() {
  return `Monthly Commodity Prices`;
}
